import { ContentCard } from "@msuite/ui/content-card";
import { Icon, icon } from "@msuite/ui/icons";
import { useVirtuoso } from "@msuite/ui/libs/virtuoso";
import { Panels } from "@msuite/ui/panels";
import { useQuery } from "@msuite/ui/query";
import { Timeline, TimelineActivityChart } from "@msuite/ui/timeline";
import { responseHandler } from "@msuite/ui/utils";
import type * as Types from "@msuite/utils/types";
import { client } from "@/hono";
import type { UserPanelBaseProps } from "../types";
import { UserTimelineAssignmentItem } from "./user-timeline-assignment-item";
import { UserTimelineAuditInsertItem } from "./user-timeline-audit-insert-item";

export function UserTimeline({ userId }: UserPanelBaseProps) {
	/** Hooks */

	/** Query */
	const { data: timeline, refetch } = useQuery({
		queryKey: ["users", userId, "timeline"],
		queryFn: async () => {
			const response = await client.users[":userId"].timeline.$get({
				param: { userId },
			});
			const data = await responseHandler(response);
			return data.timeline;
		},
	});

	const virtuosoHandles = useVirtuoso();

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<ContentCard
					title="User Timeline"
					icon={icon("PieChart")}
				>
					<TimelineActivityChart
						virtuosoHandles={virtuosoHandles}
						data={timeline}
						getDate={(item) => item.date}
						renderTooltip={() => null}
					/>
				</ContentCard>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Timeline
					timeline={timeline}
					renderItem={(type, item) => {
						if (type === "userAssignment") {
							return <UserTimelineAssignmentItem item={item as Types.UserTimelineAssignmentItem} />;
						} else if (type === "audit-insert") {
							return (
								<UserTimelineAuditInsertItem item={item as Types.UserTimelineAuditInsertItem} />
							);
						}
					}}
					renderItemMarker={(type) => {
						if (type === "userAssignment") {
							return (
								<Icon
									name="Circle"
									color="var(--color-accent-500)"
								/>
							);
						}
						if (type === "audit-insert") {
							return (
								<Icon
									name="Sparkles"
									className="stroke-accent-500 translate-y-[0.5px]"
								/>
							);
						}
					}}
					refetch={refetch}
					controls={null}
					isLoading={false}
					virtuoso={virtuosoHandles}
				/>
			</Panels.Panel>
		</Panels>
	);
}
